import type { AccountDataBundle } from './accountDataSync.ts';

export function emptyAccountDataBundle(): AccountDataBundle {
  return {
    schemaVersion: 1,
    exportedAt: Date.now(),
    stores: {
      favorites: [],
      history: [],
      blacklist: [],
      prefs: [],
      savedSearches: [],
    },
    sourceAuth: [],
  };
}

export function isUnreadableAccountBundleError(err: unknown): boolean {
  if (err instanceof SyntaxError) return true;
  if (typeof DOMException !== 'undefined' && err instanceof DOMException) {
    return err.name === 'OperationError' || err.name === 'DataError';
  }
  return false;
}

export async function mutableBundleForSourceAuthSave(
  download: () => Promise<AccountDataBundle | undefined>,
  freshBundle: () => Promise<AccountDataBundle> | AccountDataBundle = emptyAccountDataBundle,
): Promise<AccountDataBundle> {
  try {
    return (await download()) ?? (await freshBundle());
  } catch (err) {
    if (isUnreadableAccountBundleError(err)) {
      return freshBundle();
    }
    throw err;
  }
}

export function mergeAccountDataBundleForAutoUpload(
  localBundle: AccountDataBundle,
  existingAccountBundle: AccountDataBundle | undefined,
): AccountDataBundle {
  if (!existingAccountBundle) return localBundle;

  const localAuthSources = new Set(localBundle.sourceAuth.map((entry) => entry.source));
  const preservedSourceAuth = existingAccountBundle.sourceAuth.filter(
    (entry) => !localAuthSources.has(entry.source),
  );
  if (preservedSourceAuth.length === 0) return localBundle;

  return {
    ...localBundle,
    sourceAuth: [...preservedSourceAuth, ...localBundle.sourceAuth],
  };
}
